<template>
	<CPopover popoverClass="s-w-34 s-rounded s-text-sm s-text-gray-700">
		<template slot="trigger">
			<button class="s-appearance-none focus:s-outline-none">
				<svg
					width="20"
					height="20"
					class="s-text-current"
					fill="none"
					stroke-linecap="round"
					stroke-linejoin="round"
					stroke-width="2"
					viewBox="0 0 24 24"
					stroke="currentColor"
				>
					<path
						d="M12 5v.01M12 12v.01M12 19v.01M12 6a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2z"
					></path>
				</svg>
			</button>
		</template>
		<template slot="content">
			<JFlex class="s-items-center s-p-4 hover:s-bg-indigo-100 s-uppercase s-border-b s-border-gray-200" @click="onEdit">
				<svg
					width="14"
					height="14"
					class="s-text-current s-mr-2"
					fill="none"
					stroke-linecap="round"
					stroke-linejoin="round"
					stroke-width="2"
					viewBox="0 0 24 24"
					stroke="currentColor"
				>
					<path d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z"></path>
				</svg>
				{{ $t("core.edit") }}
			</JFlex>
			<JFlex class="s-items-center s-p-4 hover:s-bg-indigo-100 s-uppercase s-border-b s-border-gray-200" @click="onCut">
				<svg
					width="14"
					height="14"
					class="s-text-current s-mr-2"
					fill="none"
					stroke-linecap="round"
					stroke-linejoin="round"
					stroke-width="2"
					viewBox="0 0 24 24"
					stroke="currentColor"
				>
					<path
						d="M8 5H6a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2v-1M8 5a2 2 0 002 2h2a2 2 0 002-2M8 5a2 2 0 012-2h2a2 2 0 012 2m0 0h2a2 2 0 012 2v3m2 4H10m0 0l3-3m-3 3l3 3"
					></path>
				</svg>
				{{ $t("core.cut") }}
			</JFlex>
			<JFlex class="s-items-center s-p-4 hover:s-bg-indigo-100 s-uppercase s-border-b s-border-gray-200" @click="onDownloadFile">
				<svg width="14" height="14" class="s-text-current s-mr-2" fill="currentColor" viewBox="0 0 20 20">
					<path
						fill-rule="evenodd"
						d="M3 17a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm3.293-7.707a1 1 0 011.414 0L9 10.586V3a1 1 0 112 0v7.586l1.293-1.293a1 1 0 111.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z"
						clip-rule="evenodd"
					></path>
				</svg>
				{{ $t("core.download") }}
			</JFlex>
			<JFlex class="s-items-center s-p-4 hover:s-bg-indigo-100 s-text-red-600 s-uppercase" @click="onDeleteFile">
				<svg width="14" height="14" class="s-text-current s-mr-2" viewBox="0 0 24 24">
					<path fill="currentColor" d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"></path>
					<path d="M0 0h24v24H0z" fill="none"></path>
				</svg>
				{{ $t("core.delete") }}
			</JFlex>
		</template>
	</CPopover>
</template>

<script>
export default {
	methods: {
		onEdit() {
			this.$emit("action:edit")
		},
		onCut() {
			this.$emit("action:cut")
		},
		onDownloadFile() {
			this.$emit("action:downloadFile")
		},
		onDeleteFile() {
			this.$emit("action:deleteFile")
		}
	}
}
</script>
